import { SET_USER_INFO } from "../../../constants";

export const setUserInfo = (userInfo: any = []) => ({
  type: SET_USER_INFO,
  payload: userInfo,
});
